import React, { useEffect, useState } from 'react';
import { Container, Box, Card, CardContent, Typography, Button, TextField, Grid, Paper, IconButton, Stack, Chip, Dialog, DialogTitle, DialogContent, DialogActions, LinearProgress, Tooltip, Alert, MenuItem, useTheme, useMediaQuery, Divider, List, ListItem, ListItemIcon, ListItemText, Switch, Snackbar } from '@mui/material';
import BurbujasLoader from '../UIElements/BurbujasLoader';
import {
  QrCode as QrCodeIcon,
  Download as DownloadIcon,
  Print as PrintIcon,
  ListAlt as ListAltIcon,
  Add as AddIcon,
  Edit as EditIcon,
  SimCardDownload as SimCardDownloadIcon,
  Search as SearchIcon,
  HelpOutline as HelpOutlineIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  Timeline as TimelineIcon,
  BarChart as BarChartIcon,
  FileDownload as FileDownloadIcon,
  Close as CloseIcon,
  ErrorOutline as ErrorIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import { Avatar } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import QRCode from 'qrcode';
import ExcelJS from 'exceljs';

import { useAuth } from '../../context/AuthContext';
import { getCcAsistenciaEventos, cargarInscriptosMasivos, toggleEstadoQR, deleteCcAsistenciaEvento } from '../../services/cc_asistencia.service.js';
import ModalCrearCcEvento from './ModalCrearCcEvento.jsx';
import ModalListaCcParticipantes from './ModalListaCcParticipantes.jsx';

export default function CcAsistenciasMain() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { user } = useAuth();
  const [eventos, setEventos] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const currentYear = new Date().getFullYear().toString();
  const [yearFilter, setYearFilter] = useState(currentYear);
  const [monthFilter, setMonthFilter] = useState('all');

  const normalizeText = (t) => t ? t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : '';

  const handleClearFilters = () => {
    setFilterText('');
    setFechaDesde('');
    setFechaHasta('');
    setYearFilter(currentYear);
    setMonthFilter('all');
  };
  const [loadingEventos, setLoadingEventos] = useState(true);

  const formatearFecha = (fecha) => {
    if (!fecha) return '';
    const partes = fecha.split('-');
    if (partes.length === 3) return `${partes[2]}-${partes[1]}-${partes[0]}`;
    return fecha;
  };

  const formatearHorario = (texto) => {
    if (!texto) return '';
    let procesado = texto.toLowerCase();
    procesado = procesado.replace(/\bhs?\.?\b/g, '').trim();
    procesado = procesado.replace(/\b(\d{1,2})(?::(\d{2}))?\b/g, (match, hora, min) => {
      const h = hora.padStart(2, '0');
      const m = min || '00';
      return `${h}:${m}`;
    });
    procesado = procesado.replace(/\s+/g, ' ').trim();
    return procesado ? `${procesado}` : '';
  };

  const availableYears = [...new Set(eventos.map(e => parseInt(e.fecha?.split('-')[0])).filter(y => !isNaN(y)))].sort((a, b) => a - b);
  const MONTH_NAMES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedEventoToEdit, setSelectedEventoToEdit] = useState(null);

  const [showParticipantsList, setShowParticipantsList] = useState(false);
  const [selectedEvento, setSelectedEvento] = useState(null);
  const [inscriptosLista, setInscriptosLista] = useState([]);

  // QR
  const [showQRModal, setShowQRModal] = useState(false);
  const [qrCode, setQrCode] = useState('');
  const [statusMessage, setStatusMessage] = useState('Sistema listo');

  // Import
  const [showImportModal, setShowImportModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadMessage, setUploadMessage] = useState('');
  const [uploadResult, setUploadResult] = useState(null); // null | { exitoso, cargados, omitidos, errores }
  const [fileInputKey, setFileInputKey] = useState(0);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const closeImportModal = () => {
    setShowImportModal(false);
    setUploadMessage('');
    setSelectedFile(null);
    setUploadResult(null);
  };

  // Help
  const [showHelpModal, setShowHelpModal] = useState(false);

  // Snackbar feedback
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Delete confirmation
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [eventoToDelete, setEventoToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const [showToggleConfirm, setShowToggleConfirm] = useState(false);
  const [eventoToToggle, setEventoToToggle] = useState(null);
  const [isToggling, setIsToggling] = useState(false);

  const confirmToggleQR = async () => {
    if (!eventoToToggle) return;
    setIsToggling(true);
    const evento = eventoToToggle;
    const nuevoEstado = evento.estado_qr === 1 ? 0 : 1;
    // Optimistic update
    setEventos(prev => prev.map(e => e.id === evento.id ? { ...e, estado_qr: nuevoEstado } : e));
    try {
      await toggleEstadoQR(evento.id);
      setSnackbar({
        open: true,
        message: nuevoEstado === 1 ? 'QR Habilitado exitosamente.' : 'QR Deshabilitado exitosamente.',
        severity: 'success'
      });
      setShowToggleConfirm(false);
      setEventoToToggle(null);
    } catch (err) {
      // Rollback on error
      setEventos(prev => prev.map(e => e.id === evento.id ? { ...e, estado_qr: evento.estado_qr } : e));
      setSnackbar({ open: true, message: 'Error al cambiar el estado del QR', severity: 'error' });
    } finally {
      setIsToggling(false);
    }
  };

  const fetchEventos = async () => {
    setLoadingEventos(true);
    try {
      const data = await getCcAsistenciaEventos();
      setEventos(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingEventos(false);
    }
  };

  useEffect(() => {
    fetchEventos();
    const interval = setInterval(() => {
      getCcAsistenciaEventos().then(data => {
        setEventos(data);
      }).catch(err => console.error(err));
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleCreateOrEdit = (evento = null) => {
    setSelectedEventoToEdit(evento);
    setShowCreateModal(true);
  };

  const generateQR = async (evento) => {
    setSelectedEvento(evento);
    setShowQRModal(true);
    setQrCode('');
    try {
      const origin = window.location.origin;
      const qrString = `${origin}/cc-asistencias/registrar/${evento.id}`;
      const qrDataURL = await QRCode.toDataURL(qrString, { width: 300, margin: 2, color: { dark: '#000000', light: '#FFFFFF' } });
      setQrCode(qrDataURL);
    } catch (error) {
      setStatusMessage('Error al generar el código QR');
    }
  };

  const handleViewParticipants = async (evento) => {
    setSelectedEvento(evento);
    setShowParticipantsList(true);
  };

  const onDataChange = () => {
    if (selectedEvento) handleViewParticipants(selectedEvento);
    fetchEventos(); // Refresh list to update counts
  };

  const handleDeleteEvento = async () => {
    if (!eventoToDelete) return;
    setIsDeleting(true);
    try {
      await deleteCcAsistenciaEvento(eventoToDelete.id);
      setSnackbar({ open: true, message: 'Evento eliminado correctamente', severity: 'success' });
      fetchEventos();
      setShowDeleteConfirm(false);
      setEventoToDelete(null);
    } catch (err) {
      console.error(err);
      setSnackbar({ open: true, message: err.message || 'Error al eliminar el evento', severity: 'error' });
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDownloadQR = () => {
    if (!qrCode || !selectedEvento) return;

    const cursoNombre = selectedEvento.curso?.nombre || 'Curso';
    const fecha = formatearFecha(selectedEvento.fecha);
    const horario = `${selectedEvento.horario_inicio?.substring(0, 5)} a ${selectedEvento.horario_fin?.substring(0, 5)} hs`;
    const infoText = `📅 ${fecha} — 🕒 ${horario}`;
    const instructionText = 'Escaneá este código con tu celular para registrar tu asistencia.';

    const canvas = document.createElement('canvas');
    const width = 1200;
    const paddingX = 80;
    const paddingY = 80;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Helper para medir y hacer wrap de texto
    const wrapText = (text, maxWidth) => {
      const words = text.split(' ');
      const lines = [];
      let currentLine = words[0] || '';

      for (let i = 1; i < words.length; i++) {
        const testLine = currentLine + ' ' + words[i];
        const metrics = ctx.measureText(testLine);
        if (metrics.width > maxWidth) {
          lines.push(currentLine);
          currentLine = words[i];
        } else {
          currentLine = testLine;
        }
      }
      lines.push(currentLine);
      return lines;
    };

    const qrImg = new Image();
    qrImg.crossOrigin = 'anonymous';
    qrImg.onload = () => {
      // 1. Configurar tipografías y calcular dimensiones dinámicas
      const contentWidth = width - paddingX * 2;

      // Calcular líneas del título
      ctx.font = 'bold 52px "Geogrotesque Sharp", "Poppins", sans-serif';
      const titleLines = wrapText(cursoNombre, contentWidth);
      const titleLineHeight = 64;

      // Líneas de la fecha y horario
      ctx.font = '600 32px "Poppins", "Roboto", sans-serif';
      const infoLines = wrapText(infoText, contentWidth);
      const infoLineHeight = 44;

      // QR Box
      const qrBoxSize = 640;
      const qrImgSize = 560;

      // Líneas de instrucción
      ctx.font = '500 28px "Poppins", "Roboto", sans-serif';
      const instrLines = wrapText(instructionText, 600);
      const instrLineHeight = 38;

      // Calcular altura total del canvas
      const titleHeight = titleLines.length * titleLineHeight;
      const infoHeight = infoLines.length * infoLineHeight;
      const instrHeight = instrLines.length * instrLineHeight;

      const totalHeight = paddingY + titleHeight + 24 + infoHeight + 40 + qrBoxSize + 40 + instrHeight + paddingY;
      canvas.width = width;
      canvas.height = totalHeight;

      // 2. Fondo blanco
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      let currentY = paddingY;

      // 3. Dibujar Título del Curso
      ctx.fillStyle = '#1A1A1A';
      ctx.font = 'bold 52px "Geogrotesque Sharp", "Poppins", sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';

      titleLines.forEach((line) => {
        ctx.fillText(line, width / 2, currentY);
        currentY += titleLineHeight;
      });

      currentY += 16;

      // 4. Dibujar Fecha y Horario
      ctx.fillStyle = '#636465';
      ctx.font = '600 32px "Poppins", "Roboto", sans-serif';

      infoLines.forEach((line) => {
        ctx.fillText(line, width / 2, currentY);
        currentY += infoLineHeight;
      });

      currentY += 36;

      // 5. Dibujar contenedor del QR con bordes redondeados y sombra
      const qrBoxX = (width - qrBoxSize) / 2;
      const qrBoxY = currentY;
      const borderRadius = 32;

      ctx.save();
      // Sombra sutil
      ctx.shadowColor = 'rgba(0, 0, 0, 0.08)';
      ctx.shadowBlur = 30;
      ctx.shadowOffsetY = 8;

      ctx.beginPath();
      ctx.roundRect
        ? ctx.roundRect(qrBoxX, qrBoxY, qrBoxSize, qrBoxSize, borderRadius)
        : ctx.rect(qrBoxX, qrBoxY, qrBoxSize, qrBoxSize);
      ctx.fillStyle = '#FFFFFF';
      ctx.fill();

      // Borde del contenedor
      ctx.shadowColor = 'transparent';
      ctx.strokeStyle = '#E2E8F0';
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.restore();

      // Dibujar la imagen del QR dentro de la tarjeta
      const qrImgX = (width - qrImgSize) / 2;
      const qrImgY = qrBoxY + (qrBoxSize - qrImgSize) / 2;
      ctx.drawImage(qrImg, qrImgX, qrImgY, qrImgSize, qrImgSize);

      currentY += qrBoxSize + 40;

      // 6. Dibujar texto de instrucción
      ctx.fillStyle = '#64748B';
      ctx.font = '500 28px "Poppins", "Roboto", sans-serif';

      instrLines.forEach((line) => {
        ctx.fillText(line, width / 2, currentY);
        currentY += instrLineHeight;
      });

      // 7. Descargar PNG resultante
      const fileSafeName = cursoNombre
        .replace(/[^a-zA-Z0-9_\-áéíóúÁÉÍÓÚñÑ ]/g, '')
        .trim()
        .replace(/\s+/g, '_');
      const fileDate = selectedEvento.fecha ? `_${selectedEvento.fecha}` : '';

      const link = document.createElement('a');
      link.download = `QR_${fileSafeName}${fileDate}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    };

    qrImg.src = qrCode;
  };

  const handlePrintQR = () => {
    if (!qrCode || !selectedEvento) return;

    const printWindow = window.open('', '_blank');
    const cursoNombre = selectedEvento.curso?.nombre || 'Curso';
    const fecha = formatearFecha(selectedEvento.fecha);
    const horario = `${selectedEvento.horario_inicio?.substring(0, 5)} a ${selectedEvento.horario_fin?.substring(0, 5)} hs`;

    const htmlContent = `
      <html>
        <head>
        <title>Imprimir QR - ${cursoNombre}</title>
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');
            body { 
              font-family: 'Poppins', sans-serif; 
              text-align: center; 
              margin: 0;
              padding: 0;
              height: 100vh;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              background-color: white;
            }
            .container {
              width: 80%;
              max-width: 800px;
            }
            h1 {
              font-size: 42px;
              font-weight: 700;
              margin-bottom: 10px;
              color: #1A1A1A;
            }
            .info {
              font-size: 24px;
              font-weight: 600;
              color: #636465;
              margin-bottom: 40px;
            }
            .qr-box {
              margin: 20px 0;
            }
            .qr-box img {
              width: 450px;
              height: auto;
            }
            .instruction {
              font-size: 18px;
              color: #64748B;
              margin-top: 40px;
              font-weight: 500;
            }
            @media print {
              body { height: 100%; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="container">
            <h1>${cursoNombre}</h1>
            <div class="info">
              📅 ${fecha} — 🕒 ${horario}
            </div>
            <div class="qr-box">
              <img src="${qrCode}" alt="Código QR" />
            </div>
            <div class="instruction" style="font-size: 28px; font-weight: 600; color: #64748B; margin: 20px 0 30px 0;">
              Escaneá este código con tu celular para registrar tu asistencia.
            </div>
          </div>
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.print();
                window.close();
              }, 500);
            };
          </script>
        </body>
      </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  // Import
  const handleDownloadTableExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Eventos CC');

      worksheet.columns = [
        { header: 'Curso', key: 'curso', width: 40 },
        { header: 'Fecha', key: 'fecha', width: 15 },
        { header: 'Horario', key: 'horario', width: 15 },
        { header: 'Docente', key: 'docente', width: 25 },
        { header: 'Inscriptos', key: 'inscriptos', width: 12 },
        { header: 'Presentes', key: 'asistidos', width: 12 }
      ];

      filteredEventos.forEach(e => {
        worksheet.addRow({
          curso: e.curso?.nombre || e.curso_nombre,
          fecha: formatearFecha(e.fecha),
          horario: formatearHorario(e.horario),
          docente: e.docente,
          inscriptos: e.cantidad_inscriptos,
          asistidos: e.cantidad_asistidos
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Eventos_Asistencia.xlsx`;
      link.click();
    } catch (err) {
      console.error(err);
    }
  };

  // EXCEL IMPORT - TEMPLATE
  const downloadTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Plantilla Carga Masiva');
    worksheet.columns = [
      { header: 'CUIL Inscriptos', key: 'cuil', width: 25 }
    ];


    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Plantilla_Carga_Masiva.xlsx`;
    link.click();
  };

  const handleUploadFile = async () => {
    if (!selectedFile) {
      setUploadMessage("Seleccione un archivo");
      return;
    }
    if (!selectedEvento) {
      setUploadMessage("No hay un evento seleccionado");
      return;
    }
    setIsUploading(true);
    setUploadMessage('Leyendo archivo...');

    const inscriptosParseados = [];

    try {
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(selectedFile);
      const worksheet = workbook.worksheets[0];

      const filasInvalidas = [];

      worksheet.eachRow((row, index) => {
        if (index > 1) { // Skip header
          const cuilRaw = row.getCell(1).value;
          const cuilStr = cuilRaw ? String(cuilRaw).trim() : null;

          // Normalizar: quitar guiones
          const cuilNormalizado = cuilStr ? cuilStr.replace(/-/g, '') : '';

          // Validar formato: solo dígitos y exactamente 11 caracteres
          const esValido = /^\d{11}$/.test(cuilNormalizado);

          if (cuilStr && esValido) {
            inscriptosParseados.push({
              cuil: cuilNormalizado,
              evento_id: parseInt(selectedEvento.id),
              estado_asistencia: 0
            });
          } else {
            // Registrar fila inválida con el valor original para informar al usuario
            filasInvalidas.push({ fila: index, valor: cuilStr || '(vacío)' });
          }
        }
      });

      // Si hay filas inválidas, bloquear la carga y mostrar el detalle al usuario
      if (filasInvalidas.length > 0) {
        const detalleErrores = filasInvalidas
          .slice(0, 10) // Mostrar máximo 10 filas para no saturar el mensaje
          .map(e => `Fila ${e.fila}: "${e.valor}"`)
          .join('\n');
        const sufijo = filasInvalidas.length > 10 ? `\n...y ${filasInvalidas.length - 10} más.` : '';
        throw new Error(
          `Se encontraron ${filasInvalidas.length} CUIL(s) inválidos. Corrija el archivo y vuelva a intentarlo.\n\n` +
          `Recuerde: el CUIL debe tener exactamente 11 dígitos (con o sin guiones).\n\n` +
          detalleErrores + sufijo
        );
      }

      if (inscriptosParseados.length === 0) throw new Error("El archivo no contiene CUILs válidos. Verifique que la columna A tenga los CUILs a partir de la fila 2.");

      // Validar cupo en el frontend antes de enviar (opcional pero recomendado para feedback rápido)
      const cupoMaximo = selectedEvento.cupo || 0;
      if (cupoMaximo > 0) {
        const inscriptosActuales = selectedEvento.cantidad_inscriptos || 0;
        const totalTrasImportar = inscriptosActuales + inscriptosParseados.length;

        if (totalTrasImportar > cupoMaximo) {
          throw new Error(`La importación superaría el cupo máximo del evento (${cupoMaximo}).\nPersonas en el archivo: ${inscriptosParseados.length}`);
        }
      }

      setUploadMessage(`Verificando ${inscriptosParseados.length} CUILs en CiDi... (puede tardar unos segundos)`);

      const { cargarInscriptosMasivos } = await import('../../services/cc_asistencia.service.js');
      const resultado = await cargarInscriptosMasivos({ inscriptos: inscriptosParseados });

      await fetchEventos();
      setUploadResult({
        exitoso: true,
        cargados: resultado.cargados ?? 0,
        omitidos: resultado.omitidos ?? 0,
        errores: resultado.errores ?? []
      });

    } catch (err) {
      setErrorMessage(err.message);
      setShowErrorModal(true);
      setUploadMessage('');
      setSelectedFile(null); // Limpiar archivo automáticamente
      setFileInputKey(prev => prev + 1); // Forzar reset del input nativo
    } finally {
      setIsUploading(false);
    }
  };

  const columns = [
    { field: 'curso', headerName: 'Curso', flex: 1.5, minWidth: 250, valueGetter: (val, row) => row.curso ? `${row.curso.nombre}` : row.curso_nombre },
    {
      field: 'fecha',
      headerName: 'Fecha',
      flex: 0.8,
      minWidth: 120,
      valueFormatter: (value) => formatearFecha(value),
      sortComparator: (v1, v2) => {
        const today = new Date().toISOString().split('T')[0];
        const isUpcoming1 = v1 >= today;
        const isUpcoming2 = v2 >= today;

        if (isUpcoming1 && isUpcoming2) {
          // Ambos a futuro o hoy: del más cercano al más lejano (ascendente)
          return v1.localeCompare(v2);
        }
        if (!isUpcoming1 && !isUpcoming2) {
          // Ambos pasados: del más reciente al más antiguo (descendente)
          return v2.localeCompare(v1);
        }
        // Los futuros/hoy van primero
        return isUpcoming1 ? -1 : 1;
      }
    },
    { field: 'horario_inicio', headerName: 'Inicio', flex: 0.6, minWidth: 100, valueFormatter: (value) => value?.substring(0, 5) || '—' },
    { field: 'horario_fin', headerName: 'Fin', flex: 0.6, minWidth: 100, valueFormatter: (value) => value?.substring(0, 5) || '—' },
    { field: 'docente', headerName: 'Docente', flex: 1.2, minWidth: 200 },
    { field: 'cupo', headerName: 'Cupo', flex: 0.5, minWidth: 80, valueFormatter: (value) => value || '—' },
    { field: 'cantidad_inscriptos', headerName: 'Inscriptos', flex: 0.6, minWidth: 100 },
    { field: 'cantidad_asistidos', headerName: 'Presentes', flex: 0.6, minWidth: 100 },
    {
      field: 'acciones', headerName: 'Acciones', flex: 1.8, minWidth: 380, sortable: false, renderCell: (params) => (
        <Stack direction="row" spacing={1} alignItems="center">
          <Tooltip title={params.row.estado_qr === 1 ? 'QR Habilitado — Click para deshabilitar' : 'QR Deshabilitado — Click para habilitar'} slotProps={{ tooltip: { sx: { fontFamily: 'Poppins' } } }}>
            <Switch
              checked={params.row.estado_qr === 1}
              onChange={() => {
                setEventoToToggle(params.row);
                setShowToggleConfirm(true);
              }}
              size="small"
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': { color: '#22C55E' },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#22C55E' }
              }}
            />
          </Tooltip>
          <Tooltip title="Generar QR" slotProps={{ tooltip: { sx: { fontFamily: 'Poppins' } } }}>
            <IconButton aria-label="Generar QR" onClick={() => generateQR(params.row)} sx={{ color: 'primary.main' }} size="small"><QrCodeIcon /></IconButton>
          </Tooltip>
          <Tooltip title="Ver Participantes" slotProps={{ tooltip: { sx: { fontFamily: 'Poppins' } } }}>
            <IconButton aria-label="Ver Participantes" onClick={() => handleViewParticipants(params.row)} sx={{ color: 'primary.main' }} size="small"><ListAltIcon /></IconButton>
          </Tooltip>
          <Tooltip title="Importar Inscriptos" slotProps={{ tooltip: { sx: { fontFamily: 'Poppins' } } }}>
            <IconButton aria-label="Importar Inscriptos" onClick={() => { setSelectedEvento(params.row); setShowImportModal(true); }} sx={{ color: 'primary.main' }} size="small"><SimCardDownloadIcon /></IconButton>
          </Tooltip>
          <Tooltip title="Editar Evento" slotProps={{ tooltip: { sx: { fontFamily: 'Poppins' } } }}>
            <IconButton aria-label="Editar Evento" onClick={() => handleCreateOrEdit(params.row)} sx={{ color: 'primary.main' }} size="small"><EditIcon /></IconButton>
          </Tooltip>
          {params.row.cantidad_asistidos === 0 && (
            <Tooltip title="Eliminar Evento" slotProps={{ tooltip: { sx: { fontFamily: 'Poppins' } } }}>
              <IconButton
                aria-label="Eliminar Evento"
                onClick={() => { setEventoToDelete(params.row); setShowDeleteConfirm(true); }}
                sx={{ color: 'error.main' }}
                size="small"
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}

        </Stack>
      )
    }
  ];

  const filteredEventos = eventos.filter(e => {
    const lower = normalizeText(filterText);
    const matchesText = (
      (e.curso && normalizeText(e.curso.nombre).includes(lower)) ||
      (e.curso_cod && normalizeText(e.curso_cod).includes(lower)) ||
      (e.docente && normalizeText(e.docente).includes(lower))
    );

    const matchesDesde = fechaDesde ? e.fecha >= fechaDesde : true;
    const matchesHasta = fechaHasta ? e.fecha <= fechaHasta : true;

    const [eYear, eMonth] = e.fecha ? e.fecha.split('-') : [];
    const matchesYear = yearFilter !== 'all' ? eYear === yearFilter : true;
    const matchesMonth = monthFilter !== 'all' ? eMonth === monthFilter : true;

    const matchesRole = (user?.rol === 'REF' && user?.area) ? (e.curso?.area === user.area) : true;

    return matchesText && matchesDesde && matchesHasta && matchesYear && matchesMonth && matchesRole;
  });

  return (
    <Container maxWidth={false} sx={{ py: 4, fontFamily: 'Poppins' }}>
      {/* HEADER SECTION */}
      <Box sx={{
        mb: 4,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', md: 'center' },
        gap: 3
      }}>
        <Box sx={{ flex: '1 1 300px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <Typography variant={isMobile ? "h5" : "h4"} component="h1" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', color: '#1A1A1A', mb: 1 }}>
              Registro de Asistencia
            </Typography>
            <Tooltip title="Guía de uso">
              <IconButton onClick={() => setShowHelpModal(true)} sx={{ color: 'primary.main' }} size="small">
                <HelpOutlineIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Typography variant={isMobile ? "body2" : "subtitle1"} sx={{ color: '#5C6F82', fontFamily: 'Poppins' }}>
            Administre sus cursos presenciales, genere códigos QR y controle el presentismo de forma centralizada.
          </Typography>
        </Box>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            flexWrap: 'wrap',
            gap: 0,
            ml: { xs: 0, sm: 'auto' },
            width: { xs: '100%', sm: 'auto' },
            justifyContent: { xs: 'flex-start', sm: 'flex-end' }
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={handleDownloadTableExcel}
            startIcon={<DownloadIcon />}
            sx={{
              fontFamily: 'Geogrotesque Sharp',
              borderRadius: '8px',
              boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
              px: { xs: 1.5, md: 2 }
            }}
          >
            {isMobile ? 'EXPORTAR' : 'EXPORTAR LISTA DE CURSOS'}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleCreateOrEdit()}
            startIcon={<AddIcon />}
            sx={{
              fontFamily: 'Geogrotesque Sharp',
              borderRadius: '8px',
              boxShadow: '0 4px 12px rgba(0,123,255,0.2)',
              px: { xs: 1.5, md: 2 }
            }}
          >
            {isMobile ? 'CREAR' : 'CREAR NUEVO EVENTO'}
          </Button>
        </Stack>
      </Box>

      {/* FILTERS CARD */}
      <Card elevation={0} sx={{ border: '1px solid #E2E8F0', borderRadius: '16px', mb: 3, overflow: 'visible' }}>
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
            <TextField
              placeholder="Buscar por curso o docente..."
              size="small"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              sx={{ flexGrow: 1, minWidth: 250, bgcolor: '#fff', borderRadius: 1 }}
              InputProps={{ startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} /> }}
            />
            <TextField select label="Año" size="small" value={yearFilter} onChange={e => setYearFilter(e.target.value)} sx={{ bgcolor: '#fff', minWidth: 100, borderRadius: 1 }}>
              <MenuItem value="all"><em>Todos</em></MenuItem>
              {availableYears.map(y => <MenuItem key={y} value={y.toString()}>{y}</MenuItem>)}
            </TextField>
            <TextField select label="Mes" size="small" value={monthFilter} onChange={e => setMonthFilter(e.target.value)} sx={{ bgcolor: '#fff', minWidth: 130, borderRadius: 1 }}>
              <MenuItem value="all"><em>Todos</em></MenuItem>
              {MONTH_NAMES.map((m, i) => <MenuItem key={i} value={(i + 1).toString().padStart(2, '0')}>{m}</MenuItem>)}
            </TextField>
            <TextField
              label="Fecha Desde"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={fechaDesde}
              onChange={(e) => setFechaDesde(e.target.value)}
              size="small"
              sx={{ bgcolor: '#fff', borderRadius: 1 }}
            />
            <TextField
              label="Fecha Hasta"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={fechaHasta}
              onChange={(e) => setFechaHasta(e.target.value)}
              size="small"
              sx={{ bgcolor: '#fff', borderRadius: 1 }}
            />
            <Button
              variant="text"
              onClick={handleClearFilters}
              disabled={
                !filterText &&
                !fechaDesde &&
                !fechaHasta &&
                yearFilter === currentYear &&
                monthFilter === 'all'
              }
              sx={{ fontFamily: 'Poppins', color: 'text.secondary', fontWeight: 'bold' }}
            >
              Limpiar
            </Button>
          </Box>
          <Divider sx={{ my: 3, opacity: 0.6 }} />
          <Box sx={{ width: '100%', overflowX: 'auto' }}>
            <Box sx={{ height: 600, minWidth: 800 }}>
              <DataGrid
                rows={filteredEventos}
                columns={columns}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                initialState={{ sorting: { sortModel: [{ field: 'fecha', sort: 'asc' }] } }}
                loading={loadingEventos}
                disableSelectionOnClick
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: { xs: '0.85rem', md: '1rem' },
                  '& .MuiDataGrid-columnHeaders': { bgcolor: '#F8F9FA', color: '#3A4756', fontWeight: 600, fontFamily: 'Geogrotesque Sharp', fontSize: { xs: '0.9rem', md: '1.05rem' } },
                  '& .MuiDataGrid-cell': { py: 1.5, display: 'flex', alignItems: 'center', fontFamily: 'Poppins' },
                  '& .MuiDataGrid-row': { transition: 'background-color 0.2s', '&:hover': { bgcolor: 'rgba(0,123,255,0.04)' } }
                }}
                slots={{
                  loadingOverlay: () => (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                      <BurbujasLoader />
                    </Box>
                  )
                }}
              />
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* IMPORT EXCEL MODAL */}
      <Dialog
        open={showImportModal}
        onClose={() => { if (!isUploading) closeImportModal(); }}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: '20px', boxShadow: '0 12px 48px rgba(0,0,0,0.12)' } }}
      >
        <DialogTitle sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', fontSize: '1.5rem', py: 3 }}>
          Suba Masiva de Inscriptos
        </DialogTitle>
        <DialogContent dividers sx={{ py: 3 }}>

          {/* ── TARJETA DE RESULTADO ── */}
          {uploadResult ? (
            <Box sx={{ textAlign: 'center', py: 2 }}>
              {/* Ícono principal */}
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                  mx: 'auto',
                  mb: 3,
                  bgcolor: uploadResult.omitidos > 0 ? '#FEF3C7' : '#DCFCE7',
                  color: uploadResult.omitidos > 0 ? '#D97706' : '#16A34A',
                  boxShadow: uploadResult.omitidos > 0 ? '0 8px 16px rgba(217, 119, 6, 0.15)' : '0 8px 16px rgba(22, 163, 74, 0.15)'
                }}
              >
                {uploadResult.omitidos > 0 ? (
                  <WarningIcon sx={{ fontSize: 45 }} />
                ) : (
                  <CheckCircleIcon sx={{ fontSize: 45 }} />
                )}
              </Avatar>

              <Typography variant="h5" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', color: '#1A1A1A', mb: 1 }}>
                {uploadResult.omitidos > 0 ? 'Carga completada con observaciones' : '¡Carga realizada con éxito!'}
              </Typography>
              <Typography variant="body2" sx={{ fontFamily: 'Poppins', color: '#64748B', mb: 4, px: 2 }}>
                Se han procesado los datos para el evento: <br />
                <strong>{selectedEvento?.curso?.nombre}</strong>
              </Typography>

              {/* Chips de resumen */}
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mb: 4 }}>
                <Box sx={{
                  p: 2.5,
                  borderRadius: '16px',
                  bgcolor: '#F0FDF4',
                  border: '1px solid #BBF7D0',
                  minWidth: 140,
                  boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                }}>
                  <Typography sx={{ fontFamily: 'Geogrotesque Sharp', fontSize: '2.2rem', fontWeight: 'bold', color: '#15803D', lineHeight: 1 }}>
                    {uploadResult.cargados}
                  </Typography>
                  <Typography sx={{ fontFamily: 'Poppins', fontSize: '0.85rem', color: '#16A34A', mt: 1, fontWeight: 600 }}>Nuevos Inscriptos</Typography>
                </Box>

                {uploadResult.omitidos > 0 && (
                  <Box sx={{
                    p: 2.5,
                    borderRadius: '16px',
                    bgcolor: '#FFFBEB',
                    border: '1px solid #FEF3C7',
                    minWidth: 140,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                  }}>
                    <Typography sx={{ fontFamily: 'Geogrotesque Sharp', fontSize: '2.2rem', fontWeight: 'bold', color: '#B45309', lineHeight: 1 }}>
                      {uploadResult.omitidos}
                    </Typography>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: '0.85rem', color: '#D97706', mt: 1, fontWeight: 600 }}>No Encontrados</Typography>
                  </Box>
                )}
              </Box>

              {/* Detalle de errores si hay omitidos */}
              {uploadResult.errores?.length > 0 && (
                <Box sx={{
                  textAlign: 'left',
                  bgcolor: '#FFF9F2',
                  border: '1px solid #FFE4CC',
                  borderRadius: '16px',
                  p: 3,
                  mb: 3,
                  maxHeight: '200px',
                  overflowY: 'auto'
                }}>
                  <Typography sx={{ fontFamily: 'Poppins', fontWeight: 700, fontSize: '0.9rem', color: '#9A3412', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WarningIcon sx={{ fontSize: 18 }} /> CUILs no encontrados en CiDi:
                  </Typography>
                  <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))', gap: 1 }}>
                    {uploadResult.errores.map((e, i) => (
                      <Typography key={i} sx={{
                        fontFamily: 'Poppins',
                        fontSize: '0.8rem',
                        color: '#7C2D12',
                        bgcolor: 'rgba(255,255,255,0.5)',
                        p: 0.5,
                        borderRadius: '6px',
                        textAlign: 'center',
                        border: '1px solid rgba(154, 52, 18, 0.1)'
                      }}>
                        {e.cuil}
                      </Typography>
                    ))}
                  </Box>
                </Box>
              )}
            </Box>
          ) : (
            /* ── FORMULARIO DE CARGA ── */
            <>
              {selectedEvento && (
                <Box sx={{ mb: 3, p: 2, bgcolor: 'rgba(0,123,255,0.05)', borderRadius: '12px', border: '1px solid rgba(0,123,255,0.1)' }}>
                  <Typography variant="subtitle2" sx={{ fontFamily: 'Poppins', color: 'primary.main', fontWeight: 600, mb: 0.5, letterSpacing: 0.5 }}>
                    CURSO SELECCIONADO:
                  </Typography>
                  <Typography variant="h6" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', color: '#1A1A1A' }}>
                    {selectedEvento.curso?.nombre}
                  </Typography>
                </Box>
              )}

              <Typography variant="body1" sx={{ fontFamily: 'Poppins', color: '#334155', fontWeight: 500, mb: 2 }}>
                Siga estos pasos para realizar la carga:
              </Typography>

              <Box sx={{ mb: 3 }}>
                <Typography variant="body1" sx={{ fontFamily: 'Poppins', color: '#475569', mb: 1.5, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <span style={{ color: '#007BFF', fontWeight: 'bold' }}>1.</span>
                  <span>Descargue la <strong>plantilla oficial</strong> de inscriptos.</span>
                </Typography>
                <Button
                  variant="outlined"
                  onClick={downloadTemplate}
                  startIcon={<DownloadIcon />}
                  sx={{ fontFamily: 'Geogrotesque Sharp', borderRadius: '10px', mb: 3, fontWeight: 'bold', textTransform: 'none', px: 3 }}
                >
                  Descargar Plantilla Excel
                </Button>

                <Typography variant="body1" sx={{ fontFamily: 'Poppins', color: '#475569', mb: 1.5, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <span style={{ color: '#007BFF', fontWeight: 'bold' }}>2.</span>
                  <span>Complete la columna <strong>CUIL</strong> (11 dígitos, con o sin guiones).</span>
                </Typography>

                <Typography variant="body1" sx={{ fontFamily: 'Poppins', color: '#475569', mb: 3, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <span style={{ color: '#007BFF', fontWeight: 'bold' }}>3.</span>
                  <span>Suba el archivo aquí para registrar la asistencia.</span>
                </Typography>
              </Box>

              <Box sx={{ border: '2px dashed #E2E8F0', p: 3, borderRadius: '16px', bgcolor: '#F8FAFC', textAlign: 'center' }}>
                <Typography variant="subtitle2" sx={{ fontFamily: 'Poppins', color: '#64748B', mb: 2, fontWeight: 600 }}>
                  SELECCIONE EL ARCHIVO EXCEL (.xlsx)
                </Typography>
                <TextField
                  key={fileInputKey}
                  type="file"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    if (e.target.files[0]) {
                      setSelectedFile(e.target.files[0]);
                      setUploadMessage('');
                    }
                  }}
                  disabled={isUploading}
                  sx={{ bgcolor: '#fff', borderRadius: '10px', '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                />
              </Box>

              {uploadMessage && (
                <Alert
                  severity={uploadMessage.includes('❌') ? 'error' : 'info'}
                  sx={{ mt: 3, borderRadius: '12px', fontFamily: 'Poppins', fontWeight: 500, whiteSpace: 'pre-line' }}
                >
                  {uploadMessage}
                </Alert>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 1 }}>
          {uploadResult ? (
            /* Botón CONTINUAR en la tarjeta de resultado */
            <Button
              onClick={closeImportModal}
              variant="contained"
              sx={{
                fontFamily: 'Geogrotesque Sharp',
                fontWeight: 'bold',
                borderRadius: '10px',
                px: 5,
                py: 1.2,
                boxShadow: '0 4px 12px rgba(0,123,255,0.2)'
              }}
            >
              CONTINUAR
            </Button>
          ) : (
            /* Botones del formulario de carga */
            <>
              <Button
                onClick={closeImportModal}
                disabled={isUploading}
                sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', color: '#64748B', px: 3 }}
              >
                CANCELAR
              </Button>
              <Button
                onClick={handleUploadFile}
                variant="contained"
                disabled={isUploading || !selectedFile}
                sx={{
                  fontFamily: 'Geogrotesque Sharp',
                  fontWeight: 'bold',
                  borderRadius: '10px',
                  px: 4,
                  boxShadow: '0 4px 12px rgba(0,123,255,0.2)'
                }}
              >
                {isUploading ? <BurbujasLoader small /> : 'SUBIR ARCHIVO'}
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* QR MODAL */}
      <Dialog
        open={showQRModal}
        onClose={() => setShowQRModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '16px',
            '@media print': {
              position: 'absolute !important',
              left: '0 !important',
              top: '0 !important',
              margin: '0 !important',
              width: '100% !important',
              height: '100% !important',
              boxShadow: 'none !important',
              border: 'none !important',
              display: 'flex !important',
              alignItems: 'center !important',
              justifyContent: 'center !important',
              visibility: 'visible !important',
              zIndex: 9999
            }
          }
        }}
      >
        <DialogTitle sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', '@media print': { display: 'none' } }}>
          Código QR de Asistencia
        </DialogTitle>
        <DialogContent dividers sx={{
          '@media print': {
            border: 'none !important',
            p: '0 !important',
            m: '0 !important',
            display: 'flex !important',
            flexDirection: 'column !important',
            alignItems: 'center !important',
            justifyContent: 'center !important',
            height: 'auto !important',
            width: '100% !important'
          }
        }}>
          <Box sx={{
            textAlign: 'center',
            py: 2,
            '@media print': {
              width: '100% !important',
              display: 'flex !important',
              flexDirection: 'column !important',
              alignItems: 'center !important',
              justifyContent: 'center !important'
            }
          }}>
            <Typography variant="h4" sx={{ mb: 1, fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', color: '#1A1A1A', '@media print': { fontSize: '2.5rem !important' } }}>
              {selectedEvento?.curso?.nombre}
            </Typography>

            {/* Fecha y Horario solicitados */}
            <Typography variant="h6" sx={{ mb: 3, fontFamily: 'Poppins', color: '#636465', fontWeight: 600, '@media print': { fontSize: '1.5rem !important', color: '#000 !important' } }}>
              📅 {formatearFecha(selectedEvento?.fecha)} — 🕒 {selectedEvento?.horario_inicio?.substring(0, 5)} a {selectedEvento?.horario_fin?.substring(0, 5)} hs
            </Typography>

            <Box sx={{
              border: '1px solid #E2E8F0',
              p: 3,
              display: 'inline-block',
              borderRadius: '16px',
              bgcolor: '#fff',
              boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
              '@media print': { border: 'none !important', boxShadow: 'none !important', p: '0 !important', mt: '20px !important' }
            }}>
              {qrCode ? (
                <img
                  src={qrCode}
                  alt="QR Attendance"
                  style={{ width: '100%', maxWidth: '450px' }}
                />
              ) : (
                <BurbujasLoader />
              )}
            </Box>

            <Typography variant="body1" sx={{ mt: 3, color: '#64748B', fontFamily: 'Poppins', maxWidth: '300px', mx: 'auto' }}>
              Escaneá este código con tu celular para registrar tu asistencia.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button onClick={() => setShowQRModal(false)} sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold' }}>CERRAR</Button>
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={handleDownloadQR}
            sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', borderRadius: '8px' }}
          >
            DESCARGAR
          </Button>
          <Button
            variant="contained"
            startIcon={<PrintIcon />}
            onClick={handlePrintQR}
            sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', borderRadius: '8px' }}
          >
            IMPRIMIR QR
          </Button>
        </DialogActions>
      </Dialog>

      {/* HELP MODAL / CENTRO DE AYUDA */}
      <Dialog
        open={showHelpModal}
        onClose={() => setShowHelpModal(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: '24px', boxShadow: '0 12px 48px rgba(0,0,0,0.15)' } }}
      >
        <DialogTitle sx={{ m: 0, p: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#F8FAFC' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <HelpOutlineIcon color="primary" sx={{ fontSize: '2rem' }} />
            <Typography variant="h5" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', color: '#1A1A1A' }}>
              Guía rápida de Registro de Asistencia
            </Typography>
          </Box>
          <IconButton onClick={() => setShowHelpModal(false)} sx={{ color: '#94A3B8' }}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <Box sx={{ p: 4 }}>
            <Typography variant="body1" sx={{ fontFamily: 'Poppins', color: '#334155', mb: 4, fontSize: '1.1rem' }}>
              Bienvenido al Centro de Ayuda. Aquí encontrará los pasos clave para gestionar el presentismo de sus cursos de forma eficiente.
            </Typography>

            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Stack spacing={3}>
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      <AddIcon color="primary" /> 1. Crear un Nuevo Evento
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'Poppins', color: '#64748B', ml: 4 }}>
                      Haga clic en <strong>"CREAR NUEVO EVENTO"</strong>. Complete el curso, fecha, horario y docente.
                      <em> Si el curso no figura en el desplegable, puede darlo de alta rápidamente desde el botón <strong>"+ Crear curso"</strong> dentro del formulario.</em>
                    </Typography>
                  </Box>

                  <Box>
                    <Typography variant="subtitle1" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      <QrCodeIcon color="primary" /> 2. Automatización del QR
                    </Typography>
                    <Box sx={{ ml: 4 }}>
                      <Typography variant="body2" sx={{ fontFamily: 'Poppins', color: '#64748B', mb: 1 }}>
                        El sistema activa el QR 15 min. antes del inicio y lo desactiva 15 min. después.
                      </Typography>
                    </Box>
                  </Box>

                  <Box>
                    <Typography variant="subtitle1" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      <Switch checked={true} size="small" /> 3. Prioridad de Control Manual
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'Poppins', color: '#64748B', ml: 4 }}>
                      Puede usar el interruptor (Switch) en cualquier momento. <strong>La configuración manual desactiva las reglas automáticas</strong> para ese evento; una vez que intervenga manualmente, el sistema dejará de aplicar los tiempos automáticos.
                    </Typography>
                  </Box>

                  <Box>
                    <Typography variant="subtitle1" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      <DeleteIcon color="error" /> 4. Eliminación Segura
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'Poppins', color: '#64748B', ml: 4 }}>
                      Puede eliminar eventos sin presentes registrados. Si existen asistentes, la eliminación se bloquea para proteger los datos. Esta acción se permite en caso de errores en la carga de campos que no se pueden editar.
                    </Typography>
                  </Box>
                </Stack>
              </Grid>

              <Grid item xs={12} md={6}>
                <Stack spacing={3}>
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      <SimCardDownloadIcon color="primary" /> 5. Carga Masiva
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'Poppins', color: '#64748B', ml: 4 }}>
                      Descargue la plantilla, pegue los CUILs y suba el archivo. El sistema traerá automáticamente los datos desde CiDi.
                    </Typography>
                  </Box>

                  <Box>
                    <Typography variant="subtitle1" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      <FileDownloadIcon color="primary" /> 6. Exportación
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily: 'Poppins', color: '#64748B', ml: 4 }}>
                      Exporte la tabla completa o listas individuales a Excel para su gestión externa o archivo.
                    </Typography>
                  </Box>

                  <Box sx={{ bgcolor: 'rgba(0,123,255,0.04)', p: 2, borderRadius: '12px', border: '1px solid rgba(0,123,255,0.1)' }}>
                    <Typography variant="subtitle2" sx={{ fontFamily: 'Poppins', color: 'primary.main', fontWeight: 'bold', mb: 0.5 }}>
                      DATO CLAVE:
                    </Typography>
                    <Typography variant="caption" sx={{ fontFamily: 'Poppins', color: '#5C6F82' }}>
                      La lista se actualiza automáticamente cada 5 segundos. Verá el avance de los presentes en tiempo real mientras los alumnos escanean el código.
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#F8FAFC' }}>
          <Button
            onClick={() => setShowHelpModal(false)}
            variant="contained"
            fullWidth
            sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', py: 1.5, borderRadius: '12px' }}
          >
            ENTENDIDO, ¡GRACIAS!
          </Button>
        </DialogActions>
      </Dialog>

      {showCreateModal && (
        <ModalCrearCcEvento
          open={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          initialData={selectedEventoToEdit}
          onSuccess={(msg) => {
            fetchEventos();
          }}
        />
      )}

      {showParticipantsList && selectedEvento && (
        <ModalListaCcParticipantes
          open={showParticipantsList}
          onClose={() => setShowParticipantsList(false)}
          nombreCurso={selectedEvento.curso?.nombre}
          fechaEvento={selectedEvento.fecha}
          idEvento={selectedEvento.id}
          cupo={selectedEvento.cupo}
          onDataChange={onDataChange}
        />
      )}

      {/* MODAL ERROR DE IMPORTACIÓN (CUPO SUPERADO) */}
      <Dialog
        open={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        PaperProps={{
          sx: {
            borderRadius: '20px',
            padding: 2,
            maxWidth: '450px',
            textAlign: 'center'
          }
        }}
      >
        <DialogContent sx={{ pt: 4 }}>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              bgcolor: '#FEE2E2',
              color: '#EF4444',
              mx: 'auto',
              mb: 3,
              boxShadow: '0 8px 16px rgba(239, 68, 68, 0.15)'
            }}
          >
            <ErrorIcon sx={{ fontSize: 45 }} />
          </Avatar>

          <Typography
            variant="h5"
            sx={{
              fontFamily: 'Geogrotesque Sharp',
              fontWeight: 'bold',
              color: '#111827',
              mb: 1
            }}
          >
            Importación Fallida
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: 'Poppins',
              color: '#4B5563',
              mb: 3,
              lineHeight: 1.6,
              whiteSpace: 'pre-line'
            }}
          >
            {errorMessage}
          </Typography>

          <Alert
            severity="error"
            variant="outlined"
            sx={{
              borderRadius: '12px',
              fontFamily: 'Poppins',
              textAlign: 'left',
              bgcolor: '#FFF5F5',
              border: '1px solid #FED7D7'
            }}
          >
            No se cargó ningún registro para garantizar la integridad del cupo.
          </Alert>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button
            onClick={() => setShowErrorModal(false)}
            variant="contained"
            fullWidth
            sx={{
              fontFamily: 'Geogrotesque Sharp',
              fontWeight: 'bold',
              py: 1.5,
              borderRadius: '12px',
              bgcolor: '#EF4444',
              '&:hover': { bgcolor: '#DC2626' },
              boxShadow: '0 4px 12px rgba(239, 68, 68, 0.2)'
            }}
          >
            ENTENDIDO, VOLVER A INTENTAR
          </Button>
        </DialogActions>
      </Dialog>

      {/* MODAL ELIMINACIÓN DE EVENTO */}
      <Dialog
        open={showDeleteConfirm}
        onClose={() => !isDeleting && setShowDeleteConfirm(false)}
        PaperProps={{
          sx: { borderRadius: '20px', padding: 2, maxWidth: '450px', textAlign: 'center' }
        }}
      >
        <DialogContent sx={{ pt: 4 }}>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              bgcolor: '#FEE2E2',
              color: '#EF4444',
              mx: 'auto',
              mb: 3,
              boxShadow: '0 8px 16px rgba(239, 68, 68, 0.15)'
            }}
          >
            <DeleteIcon sx={{ fontSize: 45 }} />
          </Avatar>

          <Typography variant="h5" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', color: '#111827', mb: 1 }}>
            ¿Eliminar Registro?
          </Typography>

          <Typography variant="body1" sx={{ fontFamily: 'Poppins', color: '#4B5563', mb: 3, lineHeight: 1.6 }}>
            Esta acción eliminará permanentemente el evento <strong>{eventoToDelete?.curso?.nombre}</strong> y todos sus inscriptos asociados. Esta acción no se puede deshacer.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0, gap: 2 }}>
          <Button
            onClick={() => setShowDeleteConfirm(false)}
            variant="outlined"
            disabled={isDeleting}
            fullWidth
            sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', py: 1.5, borderRadius: '12px' }}
          >
            CANCELAR
          </Button>
          <Button
            onClick={handleDeleteEvento}
            variant="contained"
            disabled={isDeleting}
            fullWidth
            sx={{
              fontFamily: 'Geogrotesque Sharp',
              fontWeight: 'bold',
              py: 1.5,
              borderRadius: '12px',
              bgcolor: '#EF4444',
              '&:hover': { bgcolor: '#DC2626' },
              boxShadow: '0 4px 12px rgba(239, 68, 68, 0.2)'
            }}
          >
            {isDeleting ? 'ELIMINANDO...' : 'SÍ, ELIMINAR'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* TOGGLE QR CONFIRMATION MODAL */}
      <Dialog
        open={showToggleConfirm}
        onClose={() => !isToggling && setShowToggleConfirm(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: '24px', p: 1, boxShadow: '0 20px 40px rgba(0,0,0,0.1)' } }}
      >
        <DialogContent sx={{ textAlign: 'center', pb: 1 }}>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              mx: 'auto',
              mb: 3,
              bgcolor: 'warning.main',
              color: '#FFFFFF',
              boxShadow: (theme) => `0 8px 16px ${theme.palette.warning.main}4D`
            }}
          >
            <WarningIcon sx={{ fontSize: 40 }} />
          </Avatar>
          <Typography variant="h6" sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', color: '#111827', mb: 2 }}>
            Aviso de Control Manual
          </Typography>
          <Typography variant="body2" sx={{ fontFamily: 'Poppins', color: '#4B5563', mb: 2, lineHeight: 1.6 }}>
            El sistema habilita el QR automáticamente <strong>15 minutos antes</strong> y lo deshabilita <strong>15 minutos después de la hora de inicio</strong>.
            <br /><br />
            <strong>Al cambiar el estado manualmente, esta automatización se desactivará para este evento.</strong>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0, justifyContent: 'center', gap: 1 }}>
          <Button
            onClick={() => setShowToggleConfirm(false)}
            variant="outlined"
            disabled={isToggling}
            sx={{ fontFamily: 'Geogrotesque Sharp', fontWeight: 'bold', borderRadius: '12px', flex: 1 }}
          >
            CANCELAR
          </Button>
          <Button
            onClick={confirmToggleQR}
            variant="contained"
            disabled={isToggling}
            sx={{
              fontFamily: 'Geogrotesque Sharp',
              fontWeight: 'bold',
              borderRadius: '12px',
              flex: 1,
              boxShadow: 'none',
              bgcolor: 'warning.main',
              '&:hover': { bgcolor: 'warning.dark' }
            }}
          >
            {isToggling ? 'MODIFICANDO...' : 'ENTENDIDO'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* SNACKBAR FEEDBACK */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ borderRadius: '12px', fontFamily: 'Poppins', fontWeight: 500 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

    </Container>
  );
}
